/**
 * Shared human-facing copy — warm, premium, private archive tone.
 * Use for empty states, guidance, and emotional context across MyLegacyBridge.
 */

/** Core emotional line — voice, storybook, memorial, PDF, possessions, reminders */
export const CORE_EMOTIONAL_LINE = 'One day, their voice becomes priceless.';

export const PRICELESS_POSSESSIONS_LINES = {
  headline: 'Every object has a story.',
  subline: 'Preserve the reason it mattered.',
  narrative:
    'Not every memory is a portrait. Some memories live in a watch, a chair, a recipe book, a favourite hat, or an ornament kept for years.',
};

export const PRESERVATION_PROMPTS = {
  document: {
    what: 'What is this?',
    who: 'Who is connected to it?',
    why: 'Why does it matter?',
    memory: 'What memory does it carry?',
  },
  story: {
    who: 'Who is this memory about?',
    moment: 'What moment do you want future family to understand?',
    record: 'Would you like to record it instead of typing?',
  },
  memorial: {
    remember: 'What should people remember first?',
    tributes: 'Would you like family to leave tributes?',
    privacy: 'Share their story only when you choose.',
  },
};

export const STORYBOOK_SUPPORT = {
  scene: 'Start with one scene. You can come back later.',
  voice: 'Two minutes of voice is enough.',
  imperfect: 'You do not need to write perfectly — just begin.',
};

export const LEGACY_BOOK_COPY = {
  previewTitle: 'Preview your legacy book',
  prepareAi: 'Prepare with AI',
  reviewBeforeExport: 'Review before export',
  downloadKeepsake: 'Download keepsake PDF',
  reviewDraftPdf: 'Review draft PDF',
  downloadBackup: 'Download backup (JSON)',
  aiHelper:
    'AI helps organise and polish what you have preserved. You stay in control before anything is exported.',
};

export const MEMORIAL_HUMAN = {
  privateSpace: 'Create a private memorial space when the time is right.',
  shareWhenReady: 'Share their story only when you choose.',
  tributesModerated: 'Tributes are moderated before appearing publicly.',
};
